<template>
  <div>
    <Modal
      v-model="domainModal"
      title="添加要解析的二级域名"
      @on-ok="ok"
      @on-cancel="cancelModal">
      <Alert show-icon type="success" >默认显示7个二级域名</Alert>
        <Row class="title" style="margin-bottom:10px;">
          <h4 :style="{float: 'left'}" style="line-height:24px">
            <Tooltip content="添加要进行解析的二级域名" transfer>新增二级域名</Tooltip>
          </h4>
          <Button icon="md-add" type="primary" size="small" style="margin: 0px 12px" @click="addEnvItem"></Button>
        </Row>
        <Row>
          <div v-for="(env, index) in domainData" :key="index">
            <Form ref="globalEnvForm" :model="env" :rules="envRules" inline @submit.prevent="onSubmit">
              <FormItem prop="envName" style="width: 100%">
                  <Input v-model="env.envName" placeholder="请填写要解析的二级域名" style="width: 400px" size="small"/>
                  <Button icon="md-close" @click="removeEnvItem(index)"></Button>
              </FormItem>
            </Form>
          </div>
        </Row>
        <div slot="footer">
          <Button type="primary" :loading="submitLoading" @click="ok">提交</Button>
        </div>
    </Modal>
  </div>
</template>

<script>

import { createDnsRecord } from '@/api/opscenter'

export default {
  name: 'DnsRecord',
  data () {
    return {
      domainModal: false,
      domainName: '',
      node: null,
      company: null,
      submitLoading: false,
      domainData: [],
      defaultDomains: ['us', 'ca', 'de', 'fr', 'uk', 'es', 'it', 'jp'],
      envRules: {
        envName: { required: true, trigger: 'blur', message: '域名不能为空' }
      }
    }
  },
  created: function () {
  },
  methods: {
    onSubmit () {
      return false
    },
    // 表单校验
    validForm () {
      let allValid = true
      for (let i in this.$refs.globalEnvForm) {
        this.$refs.globalEnvForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      return allValid
    },
    show (name, node, company, dnsTarget) {
      this.domainModal = true
      this.domainName = name
      this.node = node
      this.company = company
      this.dnsTarget = dnsTarget
      this.defaultDomainsInit()
    },
    batchShow (lst) {
      this.domainModal = true
      for (let i in lst) {
        this.defaultDomainsInitBatch(lst[i].DomainName)
      }
    },
    defaultDomainsInit () {
      for (let i in this.defaultDomains) {
        this.domainData.push({
          envName: this.defaultDomains[i] + '.' + this.domainName
        })
      }
    },
    defaultDomainsInitBatch (domainName) {
      for (let i in this.defaultDomains) {
        this.domainData.push({
          envName: this.defaultDomains[i] + '.' + domainName
        })
      }
    },
    cancelModal () {
      this.domainData = []
    },
    removeEnvItem (index) {
      this.domainData.splice(index, 1)
    },
    addEnvItem () {
      this.domainData.push({
        envName: '.' + this.domainName
      })
    },
    ok () {
      const allValid = this.validForm()
      if (allValid) {
        this.submitLoading = true
        let data = {
          domain_name: this.domainName,
          names: this.domainData.map(item => item.envName),
          node: this.node,
          company: this.company,
          dnsTarget: this.dnsTarget
        }
        console.log(data)
        createDnsRecord(data).then(res => {
          this.$Notice.success({
            title: '操作成功！'
          })
          this.submitLoading = false
          this.cancelModal()
        }).catch(res => {
          this.submitLoading = false
          this.cancelModal()
          console.log(res.response)
          if (res.request) {
            this.$Notice.error({
              title: '操作失败！',
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '操作失败！'
            })
          }
        })
      } else {
        this.$Notice.warning({
          title: '表单未填写完整，请检查！'
        })
      }
      this.cancelModal()
    }
  }
}
</script>

<style scoped>

</style>
